export default {
  width: 38,
  height: 38,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M36 19c0 9.389-7.611 17-17 17S2 28.389 2 19 9.611 2 19 2s17 7.611 17 17Zm2 0c0 10.493-8.507 19-19 19S0 29.493 0 19 8.507 0 19 0s19 8.507 19 19Zm-12.686 0-9.471 5.468V13.532L25.314 19Zm1-1.732c1.334.77 1.334 2.694 0 3.464l-9.471 5.469c-1.333.77-3-.193-3-1.733V13.532c0-1.54 1.667-2.502 3-1.732l9.471 5.468Z" />
  `,
}
